import {dateTime} from "services/date";
import {Floor} from "../../../types/Floor";

/**
 * Transform the given floor by deserializing object properties
 *
 * @internal
 * @param floor
 */
export default function deserializeFloor(floor: any): Floor {
    floor.created_at = dateTime(floor.created_at)
    floor.updated_at = dateTime(floor.updated_at)

    return floor;
}